'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./OrderInput.less');

var _default = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(_default, _React$Component);

    function _default(props) {
        (0, _classCallCheck3.default)(this, _default);

        var _this = (0, _possibleConstructorReturn3.default)(this, (_default.__proto__ || (0, _getPrototypeOf2.default)(_default)).call(this, props));

        _this.focus = function () {
            _this.refs.input.focus();
        };

        _this.getValue = function () {
            return _this.refs.input.value;
        };

        _this.onChange = function () {
            _this.props.onChange(_this.refs.input.value);
        };

        _this._select = function () {
            setTimeout(function () {
                return _this.refs.input.select();
            }, 50);
        };

        _this.uniqueId = '' + Math.random();
        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(_default, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.select) {
                this._select();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.select && !this.props.select) {
                this._select();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var style = {};
            var errorMessage = $.trim(this.props.errorMessage);
            var error = this.props.error;
            var success = this.props.success;

            if (this.props.center) {
                style.textAlign = 'center';
            }

            if (this.props.ltrOnRtl) {
                style.direction = 'ltr';
                style.textAlign = 'right';
            }

            if (errorMessage && error) {
                _lodash2.default.defer(function () {
                    var width = $(_this2.refs.errormessage).width();
                    $(_this2.refs.inner).width(width);
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'openrest_checkoutinput_wrapper ' + (error ? 'error' : '') + ' ' + (success ? 'success' : '') },
                _react2.default.createElement(
                    'i',
                    { 'data-hook': 'error', className: 'wixrest-icon wixrest-explanation ' + (this.props.noErrorSymbol ? 'hidden' : '') },
                    _react2.default.createElement(
                        'svg',
                        { width: '18px', height: '18px', viewBox: '0 0 18 18' },
                        _react2.default.createElement(
                            'g',
                            { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
                            _react2.default.createElement(
                                'g',
                                { id: 'Open-Search-Error', transform: 'translate(-157.000000, -62.000000)' },
                                _react2.default.createElement(
                                    'g',
                                    { id: 'Error-Circle', transform: 'translate(157.000000, 62.000000)' },
                                    _react2.default.createElement('circle', { id: 'Oval-3', fill: '#D7233E', cx: '9', cy: '9', r: '9' }),
                                    _react2.default.createElement('polygon', { id: 'Path', fill: '#FFFFFF', points: '8 4 8 10 10 10 10 4' }),
                                    _react2.default.createElement('polygon', { id: 'Path-Copy', fill: '#FFFFFF', points: '8 12 8 14 10 14 10 12' })
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement('i', { className: 'wixrest-icon wixrest-check ' + (this.props.noCheckSymbol ? 'hidden' : '') }),
                _react2.default.createElement(
                    'div',
                    { className: 'errormessage ' + (this.props.errorPosition || 'end') + ' ' + (errorMessage ? '' : 'hidden'), 'aria-hidden': !error },
                    _react2.default.createElement(
                        'div',
                        { className: 'inner', ref: 'inner' },
                        _react2.default.createElement(
                            'span',
                            { ref: 'errormessage', role: 'alert', id: 'order-input-error_' + this.uniqueId, 'data-hook': 'error_content' },
                            errorMessage
                        )
                    ),
                    _react2.default.createElement(
                        'svg',
                        { width: 10, height: 6 },
                        _react2.default.createElement('path', { d: 'M5 6 L0 0 L10 0 Z' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'titlehider' },
                    this.props.title
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'title', id: 'order-input-label_' + this.uniqueId },
                    this.props.title
                ),
                _react2.default.createElement('input', {
                    'data-hook': this.props.dataHook,
                    'aria-labelledby': 'order-input-label_' + this.uniqueId,
                    'aria-describedby': error ? 'order-input-error_' + this.uniqueId : '',
                    ref: 'input',
                    value: this.props.value || '',
                    onChange: this.onChange,
                    onBlur: this.props.onBlur,
                    onFocus: this.props.onFocus,
                    style: style })
            );
        }
    }]);
    return _default;
}(_react2.default.Component), _class.displayName = "OrderInput", _class.propTypes = {
    title: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    select: _propTypes2.default.bool,
    success: _propTypes2.default.bool,
    noErrorSymbol: _propTypes2.default.bool,
    noCheckSymbol: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string,
    errorPosition: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    center: _propTypes2.default.bool,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    dataHook: _propTypes2.default.string
}, _class.defaultProps = {
    select: false,
    onChange: function onChange() {},
    onFocus: function onFocus() {},
    onBlur: function onBlur() {}
}, _temp);

exports.default = _default;